// Grid layout for consultation heading and form
document.addEventListener("DOMContentLoaded", function () {
  // Find the consultation heading section
  const headingSection = document.querySelector('[id*="consultation_heading"]');
  const formSection = document.querySelector('[id*="17688523057bd33f90"]');

  if (headingSection && formSection) {
    // Create a wrapper container
    const wrapper = document.createElement("div");
    wrapper.className = "consultation-wrapper";
    wrapper.style.cssText = `
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 4rem;
      align-items: start;
      max-width: 1200px;
      margin: 0 auto;
      background-color: #ffffff;
      padding: 4rem 2rem;
      width: 100%;
      box-sizing: border-box;
    `;

    // Insert wrapper before heading section
    headingSection.parentNode.insertBefore(wrapper, headingSection);

    // Move both sections into the wrapper
    wrapper.appendChild(headingSection);
    wrapper.appendChild(formSection);

    // Find and style form fields within the shadow DOM
    const formsEmbed = formSection.querySelector("shopify-forms-embed");
    if (formsEmbed) {
      // Scale up the form embed itself
      formsEmbed.style.cssText = `
        transform: scale(1.2);
        transform-origin: top left;
        width: calc(100% / 1.2);
      `;

      // Wait a bit for the shadow DOM to render
      setTimeout(function () {
        const shadowRoot = formsEmbed.shadowRoot;
        if (shadowRoot) {
          // Add styles to shadow DOM
          const style = document.createElement("style");
          style.textContent = `
            * {
              box-sizing: border-box !important;
            }
            
            input[type="text"],
            input[type="email"],
            input[type="tel"],
            input[type="number"],
            textarea,
            select,
            .form-input-field,
            .form-field,
            [class*="input"] {
              width: 100% !important;
              max-width: 100% !important;
              padding: 18px 20px !important;
              font-size: 1.1rem !important;
              min-height: 50px !important;
              box-sizing: border-box !important;
              display: block !important;
            }
            
            textarea {
              min-height: 150px !important;
            }
            
            .form-field-container,
            .form-input-container,
            [class*="fieldContainer"],
            [class*="container"] input {
              width: 100% !important;
            }
            
            button[type="submit"],
            [type="submit"] {
              width: 100% !important;
              max-width: 100% !important;
              padding: 18px 28px !important;
              font-size: 1.2rem !important;
              min-height: 55px !important;
              box-sizing: border-box !important;
            }
            
            form {
              width: 100% !important;
            }
          `;
          shadowRoot.appendChild(style);
        }
      }, 500);
    }

    // Add responsive behavior
    function updateLayout() {
      if (window.innerWidth <= 768) {
        wrapper.style.gridTemplateColumns = "1fr";
        wrapper.style.gap = "2rem";
        wrapper.style.padding = "2rem 1rem";
        formsEmbed.style.transform = "scale(1)";
        formsEmbed.style.width = "100%";
      } else {
        wrapper.style.gridTemplateColumns = "1fr 1fr";
        wrapper.style.gap = "4rem";
        wrapper.style.padding = "4rem 2rem";
        formsEmbed.style.transform = "scale(1.2)";
        formsEmbed.style.width = "calc(100% / 1.2)";
      }
    }

    updateLayout();
    window.addEventListener("resize", updateLayout);
  }
});
